const config = {
  // url: 'http://111.229.250.183:8083/api'
  // url: 'http://192.168.3.108:8083/api'
  // url: 'http://aids.tianlong.isastro.com/api'
  // url: 'http://192.168.3.126:8083/api'
  url: 'http://aids.tianlong.isastro.com/api'
  // url: 'http://192.168.3.114:8083/api'
}

export default config
